<div class="container mx-auto p-6">
  <h2 class="text-2xl font-serif text-gold mb-6">Order Management</h2>

  <button class="btn bg-gold hover:bg-gold-dark text-white font-medium py-2 px-4 rounded mb-6" (click)="createNewOrder()">Create New Order</button>

  <div class="mt-8 hidden lg:hidden"></div>
  <div class="overflow-x-auto">
    <table class="w-full text-left border-collapse">
      <thead class="bg-gray-100">
      <tr>
        <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Order #</th>
        <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Date Purchased</th>
        <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Full Name</th>
        <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Location</th>
        <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Phone</th>
        <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Status</th>
        <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Total</th>
        <th class="px-6 py-3 text-lg font-serif text-gold border-b-2 border-gold">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let order of orders" class="hover:bg-gold hover:bg-opacity-10 transition duration-300">
        <td class="px-6 py-4 border-b border-gray-200">
          <a class="text-gold hover:text-gold-dark font-medium transition duration-300" href="#" (click)="openOrderDetails(order); $event.preventDefault()">#{{order.number}}</a>
        </td>
        <td class="px-6 py-4 border-b border-gray-200">{{order.date | date:'mediumDate'}}</td>
        <td class="px-6 py-4 border-b border-gray-200">{{order.customer.firstname + ' ' + order.customer.lastname}}</td>
        <td class="px-6 py-4 border-b border-gray-200">{{order.customer.address1}}</td>
        <td class="px-6 py-4 border-b border-gray-200">{{order.customer.phone}}</td>
        <td class="px-6 py-4 border-b border-gray-200">
          <span class="text-blue-600 font-medium">{{order.status || 'In Progress'}}</span>
        </td>
        <td class="px-6 py-4 border-b border-gray-200">
          <span class="font-medium text-gold">{{order.total | currency:'MAD'}}</span>
        </td>
        <td class="px-6 py-4 border-b border-gray-200 flex space-x-2">
          <button class="text-blue-500 hover:text-blue-600" (click)="selectOrder(order)" title="Edit">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
            </svg>
          </button>
          <button class="text-red-500 hover:text-red-600" (click)="deleteOrder(order.number)" title="Delete">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
            </svg>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <hr class="border-t-2 border-gray-200 my-6">

  <!-- Invoice Modal -->
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 modal" (click)="handleModalClick($event)" *ngIf="showInvoiceModal">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-3xl p-6 relative max-h-[80vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-serif text-gold">Invoice #{{selectedOrder?.number}}</h3>
        <button class="text-gray-500 hover:text-gray-700 text-2xl" (click)="closeInvoiceModal()">×</button>
      </div>
      <div *ngIf="selectedOrder" id="invoice-content" class="invoice-details">
        <div class="mb-6">
          <h4 class="text-lg font-semibold text-gray-700 mb-2">Customer Information</h4>
          <p class="mb-1"><strong>Name:</strong> {{selectedOrder.customer.firstname}} {{selectedOrder.customer.lastname}}</p>
          <p class="mb-1"><strong>Address:</strong> {{selectedOrder.customer.address1}}, {{selectedOrder.customer.city}}, {{selectedOrder.customer.country}} {{selectedOrder.customer.zip}}</p>
          <p class="mb-1"><strong>Phone:</strong> {{selectedOrder.customer.phone}}</p>
          <p class="mb-1" *ngIf="selectedOrder.customer.email"><strong>Email:</strong> {{selectedOrder.customer.email}}</p>
        </div>

        <div class="mb-6">
          <h4 class="text-lg font-semibold text-gray-700 mb-2">Order Details</h4>
          <p class="mb-1"><strong>Order Date:</strong> {{selectedOrder.date | date:'medium'}}</p>
          <p class="mb-1"><strong>Status:</strong> {{selectedOrder.status}}</p>
          <p class="mb-1"><strong>Payment Method:</strong> {{selectedOrder.paymentMethod || 'N/A'}}</p>
          <p class="mb-1"><strong>Shipping Method:</strong> {{selectedOrder.shippingMethod || 'N/A'}}</p>
        </div>

        <div class="mb-6">
          <h4 class="text-lg font-semibold text-gray-700 mb-2">Items</h4>
          <table class="w-full border-collapse">
            <thead>
            <tr class="bg-gray-100">
              <th class="px-4 py-2 text-left border-b border-gray-200">Product</th>
              <th class="px-4 py-2 text-left border-b border-gray-200">Quantity</th>
              <th class="px-4 py-2 text-left border-b border-gray-200">Unit Price</th>
              <th class="px-4 py-2 text-left border-b border-gray-200">Total</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of selectedOrder.items">
              <td class="px-4 py-2 border-b border-gray-200">
                {{item.product.name}}
                <span *ngIf="item.option"> ({{item.option.label}})</span>
                <br>
                <small class="text-gray-600">{{item.product.description}}</small>
              </td>
              <td class="px-4 py-2 border-b border-gray-200">{{item.quantity}}</td>
              <td class="px-4 py-2 border-b border-gray-200">{{item.price | currency:'MAD'}}</td>
              <td class="px-4 py-2 border-b border-gray-200">{{(item.price * item.quantity) | currency:'MAD'}}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="text-right">
          <h4 class="text-lg font-semibold text-gold">Total: {{selectedOrder.total | currency:'MAD'}}</h4>
        </div>
      </div>
      <div class="mt-4 text-right flex justify-end space-x-4">
        <button class="btn bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded" (click)="downloadInvoice()">Download PDF</button>
        <button class="btn bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded" (click)="closeInvoiceModal()">Close</button>
      </div>
    </div>
  </div>

  <!-- Order Form -->
  <div class="mt-6" *ngIf="isEditing || isCreating">
    <h3 class="text-xl font-serif text-gold mb-4">{{isCreating ? 'Create Order' : 'Edit Order'}}</h3>
    <form *ngIf="selectedOrder" class="space-y-6">
      <div class="bg-white shadow rounded-lg p-6">
        <h4 class="text-lg font-semibold text-gray-700 mb-4">Customer Information</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">First Name</label>
            <input [(ngModel)]="selectedOrder.customer.firstname" name="firstname" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Last Name</label>
            <input [(ngModel)]="selectedOrder.customer.lastname" name="lastname" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Phone</label>
            <input [(ngModel)]="selectedOrder.customer.phone" name="phone" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Address</label>
            <input [(ngModel)]="selectedOrder.customer.address1" name="address1" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">City</label>
            <input [(ngModel)]="selectedOrder.customer.city" name="city" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Country</label>
            <input [(ngModel)]="selectedOrder.customer.country" name="country" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">Zip</label>
            <input [(ngModel)]="selectedOrder.customer.zip" name="zip" type="number" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
          </div>
        </div>
      </div>

      <div class="bg-white shadow rounded-lg p-6">
        <div class="flex justify-between items-center mb-4">
          <h4 class="text-lg font-semibold text-gray-700">Items</h4>
          <button type="button" class="btn bg-green-500 hover:bg-green-600 text-white py-1 px-3 rounded" (click)="addItem()">Add Item</button>
        </div>
        <div *ngFor="let item of selectedOrder.items; let i = index" class="mb-4 pb-4 border-b border-gray-200">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700">Product Name</label>
              <input [(ngModel)]="item.product.name" [name]="'productName' + i" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Price</label>
              <input [(ngModel)]="item.price" [name]="'price' + i" type="number" class="mt-1 block w-full border border-gray-300 rounded-md p-2" (change)="calculateTotal()">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700">Quantity</label>
              <input [(ngModel)]="item.quantity" [name]="'quantity' + i" type="number" class="mt-1 block w-full border border-gray-300 rounded-md p-2" (change)="calculateTotal()">
            </div>
          </div>
          <button class="btn bg-red-500 hover:bg-red-600 text-white py-1 px-3 rounded mt-2" (click)="removeItem(i)">Remove</button>
        </div>
      </div>

      <div class="bg-white shadow rounded-lg p-6">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Status</label>
          <select [(ngModel)]="selectedOrder.status" name="status" class="mt-1 block w-full border border-gray-300 rounded-md p-2">
            <option>In Progress</option>
            <option>Completed</option>
            <option>Cancelled</option>
          </select>
        </div>
        <div class="text-right">
          <p class="text-lg font-semibold text-gold">Total: {{selectedOrder.total | currency:'MAD'}}</p>
        </div>
      </div>

      <div class="flex justify-end space-x-4">
        <button type="button" class="btn bg-gold hover:bg-gold-dark text-white py-2 px-4 rounded" (click)="saveOrder()">Save</button>
        <button type="button" class="btn bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded" (click)="resetForm()">Cancel</button>
      </div>
    </form>
  </div>
</div>
